import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useLocation, useHistory } from 'react-router-dom';
import qs from 'querystring';

import { useAppContext } from '@prisjakt/ui-app-context';
import NewsletterSignup from '@prisjakt/ui-newsletter-signup';
import Modal from '../modal';

export const NEWSLETTER_PARAM = 'signup-for-our-newsletter';

const StyledNewsletterSignup = styled(NewsletterSignup)`
  width: 100%;
`;

const NewsLetterSignupModal = () => {
  const { t } = useAppContext();
  const history = useHistory();
  const location = useLocation();

  const close = useCallback(() => {
    // Remove the `NEWSLETTER_PARAM` from the URL which closes the modal
    const params = qs.parse(location.search.substr(1));
    delete params[NEWSLETTER_PARAM];
    location.search = qs.stringify(params);

    history.push(location);
  }, [history, location]);

  return (
    <Modal isOpen width={500} onRequestClose={close}>
      <StyledNewsletterSignup
        stacked
        title={t('footer', 'newsletter.title')}
        description={t('footer', 'newsletter.sub-title')}
      />
    </Modal>
  );
};

export default NewsLetterSignupModal;
